import { render, staticRenderFns } from "./TawkToChat.vue?vue&type=template&id=1af157f8&scoped=true"
import script from "./TawkToChat.vue?vue&type=script&lang=js"
export * from "./TawkToChat.vue?vue&type=script&lang=js"
import style0 from "./TawkToChat.vue?vue&type=style&index=0&id=1af157f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af157f8",
  null
  
)

export default component.exports